var _a;
const siteUrl = process.env.PUBLIC_URL;
const almeApiHostName = process.env.REACT_APP_ALME_API_HOST;
const consumerCenterPreLoginURLs = (_a = process.env.REACT_APP_ConsumerCenter_PreLoginURLs) === null || _a === void 0 ? void 0 : _a.split(',');
const version = process.env.VERSION;
const isProduction = process.env.IsProduction === "true";
export { almeApiHostName, siteUrl, consumerCenterPreLoginURLs, version, isProduction, };
